import { FloorPlanStatusEnum } from '@api/enum';
import { IFloorPlanModel } from '@api/models';
import { createFloorPlan, updateFloorPlan, updateFloorPlanImage } from '@api/services/site-walk.service';
import { useMutation } from '@tanstack/react-query';

import { useMemo } from 'react';
import * as Yup from 'yup';

/* -------------------------------------------------------------------------------------------------
 * Hook: useRFIsProcoreShareForm
 * -----------------------------------------------------------------------------------------------*/

interface IUpdatefloorPlanOptions {
    clientId: string;
    projectId: string;
    floorPlan: IFloorPlanModel;
}

const useUpdateFloorPlanImageForm = (options: IUpdatefloorPlanOptions) => {
    const { clientId, projectId, floorPlan } = options;

    const schema = useMemo(() => {
        return Yup.object({
            file: Yup.string().required('This field is required'),
        });
    }, []);

    const initialValues: Pick<IFloorPlanModel, 'file' | 'imageName' | 'imageUrl'> = useMemo(() => {
        if (!floorPlan) {
            return {
                file: null as File,
                imageName: '',
                imageUrl: '',
            };
        }
        return {
            file: floorPlan.file,
            imageName: floorPlan.imageName,
            imageUrl: floorPlan.imageUrl,
        };
    }, []);

    const updateFloorPlanImageMutation = useMutation((payload: FormData) =>
        updateFloorPlanImage(clientId, projectId, floorPlan._id, payload)
    );

    const submit = async (values: Pick<IFloorPlanModel, 'file'>) => {
        const formData = new FormData();

        formData.append('file', values.file);

        try {
            await updateFloorPlanImageMutation.mutateAsync(formData);
        } catch (err: any) {
            throw new Error(err);
        }
    };

    return {
        initialValues,
        schema,
        isSubmitting: updateFloorPlanImageMutation.isLoading,
        submit,
    };
};

export default useUpdateFloorPlanImageForm;
